module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "container-wrapper"
  }, [_c('div', {
    staticClass: "breadcrumb-wrapper"
  }, [_vm._v("平台装饰")]), _vm._v(" "), _c('div', {
    staticClass: "search-wrapper"
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.queryForm
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "装饰说明"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "模糊搜索",
      "clearable": ""
    },
    model: {
      value: (_vm.queryForm.decorationDesc),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "decorationDesc", $$v)
      },
      expression: "queryForm.decorationDesc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "装饰位置"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "200px"
    },
    model: {
      value: (_vm.queryForm.decorationPosition),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "decorationPosition", $$v)
      },
      expression: "queryForm.decorationPosition"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": 0
    }
  }), _vm._v(" "), _vm._l((_vm.positionOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  })], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "160px"
    },
    model: {
      value: (_vm.queryForm.displayStatus),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "displayStatus", $$v)
      },
      expression: "queryForm.displayStatus"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": 0
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "生效中",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "已停用",
      "value": 2
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "待生效",
      "value": 3
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.clickReset
    }
  }, [_vm._v("重置")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.queryList
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('div', {
    staticClass: "action-wrapper"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.clickAdd
    }
  }, [_vm._v("+ 新增")])], 1), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "border": "",
      "data": _vm.listData
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "创建ID",
      "prop": "id",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "装饰位置",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_vm._v(_vm._s(_vm.getPositionName(row.decorationPosition)))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "装饰说明",
      "prop": "decorationDesc",
      "min-width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "图片",
      "min-width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('div', {
          staticClass: "img-cell"
        }, [([5, 6].indexOf(row.decorationPosition) !== -1) ? [(row.singleImage && row.singleImage.imageUrl) ? _c('el-popover', {
          attrs: {
            "placement": "right",
            "title": "大图浏览",
            "trigger": "hover"
          }
        }, [_c('img', {
          attrs: {
            "width": "300",
            "src": row.singleImage.imageUrl,
            "alt": ""
          }
        }), _vm._v(" "), _c('img', {
          staticClass: "list-img",
          attrs: {
            "slot": "reference",
            "src": row.singleImage.imageUrl,
            "alt": ""
          },
          slot: "reference"
        })]) : _c('span', [_vm._v("-")])] : ([1, 8].indexOf(row.decorationPosition) !== -1) ? [(row.singleImage && row.singleImage.imageUrl) ? _c('el-popover', {
          attrs: {
            "placement": "right",
            "title": "大图浏览",
            "trigger": "hover"
          }
        }, [_c('img', {
          attrs: {
            "width": "300",
            "src": row.singleImage.imageUrl,
            "alt": ""
          }
        }), _vm._v(" "), _c('img', {
          staticClass: "list-img",
          attrs: {
            "slot": "reference",
            "src": row.singleImage.imageUrl,
            "alt": ""
          },
          slot: "reference"
        })]) : _c('span', [_vm._v("-")])] : ([2, 3].indexOf(row.decorationPosition) !== -1) ? [(row.runEndpointIcons) ? _c('div', {
          staticClass: "multi-img-row"
        }, [(row.runEndpointIcons.startPointImage) ? _c('el-popover', {
          attrs: {
            "placement": "right",
            "title": "起点图标",
            "trigger": "hover"
          }
        }, [_c('img', {
          attrs: {
            "width": "300",
            "src": row.runEndpointIcons.startPointImage,
            "alt": ""
          }
        }), _vm._v(" "), _c('img', {
          staticClass: "thumb-img",
          attrs: {
            "slot": "reference",
            "src": row.runEndpointIcons.startPointImage,
            "alt": ""
          },
          slot: "reference"
        })]) : _vm._e(), _vm._v(" "), (row.runEndpointIcons.endPointImage) ? _c('el-popover', {
          attrs: {
            "placement": "right",
            "title": "终点图标",
            "trigger": "hover"
          }
        }, [_c('img', {
          attrs: {
            "width": "300",
            "src": row.runEndpointIcons.endPointImage,
            "alt": ""
          }
        }), _vm._v(" "), _c('img', {
          staticClass: "thumb-img",
          attrs: {
            "slot": "reference",
            "src": row.runEndpointIcons.endPointImage,
            "alt": ""
          },
          slot: "reference"
        })]) : _vm._e(), _vm._v(" "), (row.runEndpointIcons.locationIcon) ? _c('el-popover', {
          attrs: {
            "placement": "right",
            "title": "定位图标",
            "trigger": "hover"
          }
        }, [_c('img', {
          attrs: {
            "width": "300",
            "src": row.runEndpointIcons.locationIcon,
            "alt": ""
          }
        }), _vm._v(" "), _c('img', {
          staticClass: "thumb-img",
          attrs: {
            "slot": "reference",
            "src": row.runEndpointIcons.locationIcon,
            "alt": ""
          },
          slot: "reference"
        })]) : _vm._e()], 1) : _c('span', [_vm._v("-")])] : (row.decorationPosition === 4) ? [(row.pointImages && row.pointImages.length) ? _c('div', {
          staticClass: "multi-img-row"
        }, [_vm._l((row.pointImages), function(point, idx) {
          return [(point.notPassedUrl) ? _c('el-popover', {
            key: 'np' + idx,
            attrs: {
              "placement": "right",
              "title": "未通过",
              "trigger": "hover"
            }
          }, [_c('img', {
            attrs: {
              "width": "300",
              "src": point.notPassedUrl,
              "alt": ""
            }
          }), _vm._v(" "), _c('img', {
            staticClass: "thumb-img",
            attrs: {
              "slot": "reference",
              "src": point.notPassedUrl,
              "alt": ""
            },
            slot: "reference"
          })]) : _vm._e(), _vm._v(" "), (point.preparingUrl) ? _c('el-popover', {
            key: 'pr' + idx,
            attrs: {
              "placement": "right",
              "title": "准备中",
              "trigger": "hover"
            }
          }, [_c('img', {
            attrs: {
              "width": "300",
              "src": point.preparingUrl,
              "alt": ""
            }
          }), _vm._v(" "), _c('img', {
            staticClass: "thumb-img",
            attrs: {
              "slot": "reference",
              "src": point.preparingUrl,
              "alt": ""
            },
            slot: "reference"
          })]) : _vm._e(), _vm._v(" "), (point.passedUrl) ? _c('el-popover', {
            key: 'pa' + idx,
            attrs: {
              "placement": "right",
              "title": "已通过",
              "trigger": "hover"
            }
          }, [_c('img', {
            attrs: {
              "width": "300",
              "src": point.passedUrl,
              "alt": ""
            }
          }), _vm._v(" "), _c('img', {
            staticClass: "thumb-img",
            attrs: {
              "slot": "reference",
              "src": point.passedUrl,
              "alt": ""
            },
            slot: "reference"
          })]) : _vm._e()]
        })], 2) : _c('span', [_vm._v("-")])] : (row.decorationPosition === 7) ? [(row.themeContent) ? _c('div', {
          staticClass: "multi-img-row"
        }, [(row.themeContent.backgrounds) ? [(row.themeContent.backgrounds.tabBarBg) ? _c('el-popover', {
          attrs: {
            "placement": "right",
            "title": "底部导航背景",
            "trigger": "hover"
          }
        }, [_c('img', {
          attrs: {
            "width": "300",
            "src": row.themeContent.backgrounds.tabBarBg,
            "alt": ""
          }
        }), _vm._v(" "), _c('img', {
          staticClass: "thumb-img",
          attrs: {
            "slot": "reference",
            "src": row.themeContent.backgrounds.tabBarBg,
            "alt": ""
          },
          slot: "reference"
        })]) : _vm._e(), _vm._v(" "), (row.themeContent.backgrounds.homePageBg) ? _c('el-popover', {
          attrs: {
            "placement": "right",
            "title": "首页背景",
            "trigger": "hover"
          }
        }, [_c('img', {
          attrs: {
            "width": "300",
            "src": row.themeContent.backgrounds.homePageBg,
            "alt": ""
          }
        }), _vm._v(" "), _c('img', {
          staticClass: "thumb-img",
          attrs: {
            "slot": "reference",
            "src": row.themeContent.backgrounds.homePageBg,
            "alt": ""
          },
          slot: "reference"
        })]) : _vm._e(), _vm._v(" "), (row.themeContent.backgrounds.myPageBg) ? _c('el-popover', {
          attrs: {
            "placement": "right",
            "title": "我的页面背景",
            "trigger": "hover"
          }
        }, [_c('img', {
          attrs: {
            "width": "300",
            "src": row.themeContent.backgrounds.myPageBg,
            "alt": ""
          }
        }), _vm._v(" "), _c('img', {
          staticClass: "thumb-img",
          attrs: {
            "slot": "reference",
            "src": row.themeContent.backgrounds.myPageBg,
            "alt": ""
          },
          slot: "reference"
        })]) : _vm._e(), _vm._v(" "), (row.themeContent.backgrounds.squarePageBg) ? _c('el-popover', {
          attrs: {
            "placement": "right",
            "title": "广场页背景",
            "trigger": "hover"
          }
        }, [_c('img', {
          attrs: {
            "width": "300",
            "src": row.themeContent.backgrounds.squarePageBg,
            "alt": ""
          }
        }), _vm._v(" "), _c('img', {
          staticClass: "thumb-img",
          attrs: {
            "slot": "reference",
            "src": row.themeContent.backgrounds.squarePageBg,
            "alt": ""
          },
          slot: "reference"
        })]) : _vm._e(), _vm._v(" "), (row.themeContent.backgrounds.sportsPageBg) ? _c('el-popover', {
          attrs: {
            "placement": "right",
            "title": "运动页背景",
            "trigger": "hover"
          }
        }, [_c('img', {
          attrs: {
            "width": "300",
            "src": row.themeContent.backgrounds.sportsPageBg,
            "alt": ""
          }
        }), _vm._v(" "), _c('img', {
          staticClass: "thumb-img",
          attrs: {
            "slot": "reference",
            "src": row.themeContent.backgrounds.sportsPageBg,
            "alt": ""
          },
          slot: "reference"
        })]) : _vm._e()] : _vm._e(), _vm._v(" "), (row.themeContent.bottomTabs && row.themeContent.bottomTabs.length) ? [_vm._l((row.themeContent.bottomTabs), function(tab, tIdx) {
          return [(tab.unselectedIcon) ? _c('el-popover', {
            key: 'u' + tIdx,
            attrs: {
              "placement": "right",
              "title": "未选中图标",
              "trigger": "hover"
            }
          }, [_c('img', {
            attrs: {
              "width": "300",
              "src": tab.unselectedIcon,
              "alt": ""
            }
          }), _vm._v(" "), _c('img', {
            staticClass: "thumb-img",
            attrs: {
              "slot": "reference",
              "src": tab.unselectedIcon,
              "alt": ""
            },
            slot: "reference"
          })]) : _vm._e(), _vm._v(" "), (tab.selectedIcon) ? _c('el-popover', {
            key: 's' + tIdx,
            attrs: {
              "placement": "right",
              "title": "选中图标",
              "trigger": "hover"
            }
          }, [_c('img', {
            attrs: {
              "width": "300",
              "src": tab.selectedIcon,
              "alt": ""
            }
          }), _vm._v(" "), _c('img', {
            staticClass: "thumb-img",
            attrs: {
              "slot": "reference",
              "src": tab.selectedIcon,
              "alt": ""
            },
            slot: "reference"
          })]) : _vm._e()]
        })] : _vm._e()], 2) : _c('span', [_vm._v("-")])] : _c('span', [_vm._v("-")])], 2)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "生效时间",
      "min-width": "220"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('span', [_vm._v(_vm._s(_vm.formatTime(row.startTime)) + " ~ " + _vm._s(_vm.formatTime(row.endTime)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "跳转链接",
      "min-width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('span', [_vm._v(_vm._s(row.redirectUrl || '-'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "操作时间",
      "min-width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('span', [_vm._v(_vm._s(_vm.formatTime(row.updateTime)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "状态",
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('span', {
          class: _vm.getDisplayStatusClass(row.displayStatus)
        }, [_vm._v("\n                  " + _vm._s(row.displayStatusName || _vm.getDisplayStatusText(row.displayStatus)) + "\n               ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "操作",
      "width": "140",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [(row.status !== 2) ? _c('el-button', {
          staticStyle: {
            "color": "#409eff"
          },
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.clickDisable(row)
            }
          }
        }, [_vm._v("停用")]) : [_c('el-button', {
          staticStyle: {
            "color": "#409eff"
          },
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.clickEnable(row)
            }
          }
        }, [_vm._v("启用")]), _vm._v(" "), _c('el-button', {
          staticStyle: {
            "color": "#409eff"
          },
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.clickEdit(row)
            }
          }
        }, [_vm._v("编辑")])]]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination-wrapper"
  }, [_c('el-pagination', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.total > 0),
      expression: "total > 0"
    }],
    attrs: {
      "layout": "total, prev, pager, next, jumper",
      "current-page": _vm.queryForm.pageNumber,
      "page-size": _vm.queryForm.pageSize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.changeCurrentPage
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.dialogTitle,
      "visible": _vm.dialogVisible,
      "width": "680px",
      "custom-class": "platform-decoration-dialog",
      "modal-append-to-body": false,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      "close": _vm.onDialogClose
    }
  }, [_c('el-form', {
    ref: "dialogForm",
    attrs: {
      "model": _vm.dialogForm,
      "rules": _vm.dialogRules,
      "label-width": "110px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "装饰说明",
      "prop": "decorationDesc"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "340px"
    },
    attrs: {
      "placeholder": "请输入装饰说明，不超过20字",
      "maxlength": "20"
    },
    model: {
      value: (_vm.dialogForm.decorationDesc),
      callback: function($$v) {
        _vm.$set(_vm.dialogForm, "decorationDesc", $$v)
      },
      expression: "dialogForm.decorationDesc"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-hint"
  }, [_vm._v("仅在后台展示，不在APP展示")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "装饰位置",
      "prop": "decorationPosition"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "220px"
    },
    on: {
      "change": _vm.onPositionChange
    },
    model: {
      value: (_vm.dialogForm.decorationPosition),
      callback: function($$v) {
        _vm.$set(_vm.dialogForm, "decorationPosition", $$v)
      },
      expression: "dialogForm.decorationPosition"
    }
  }, _vm._l((_vm.positionOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), ([1, 8].indexOf(_vm.dialogForm.decorationPosition) !== -1) ? [_c('el-form-item', [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticClass: "req-star"
  }, [_vm._v("*")]), _vm._v("图片")]), _vm._v(" "), _c('UploadImg', {
    attrs: {
      "imgUrl": _vm.dialogForm.singleImage.imageUrl
    },
    on: {
      "update:imgUrl": function($event) {
        return _vm.$set(_vm.dialogForm.singleImage, "imageUrl", $event)
      },
      "update:img-url": function($event) {
        return _vm.$set(_vm.dialogForm.singleImage, "imageUrl", $event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-hint form-hint-warn"
  }, [_vm._v("上传图片不生效，需要开发打包发版，图片提交前请提供给开发")])], 2)] : _vm._e(), _vm._v(" "), ([5, 6].indexOf(_vm.dialogForm.decorationPosition) !== -1) ? [_c('el-form-item', [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticClass: "req-star"
  }, [_vm._v("*")]), _vm._v("图片")]), _vm._v(" "), _c('UploadImg', {
    attrs: {
      "imgUrl": _vm.dialogForm.singleImage.imageUrl
    },
    on: {
      "update:imgUrl": function($event) {
        return _vm.$set(_vm.dialogForm.singleImage, "imageUrl", $event)
      },
      "update:img-url": function($event) {
        return _vm.$set(_vm.dialogForm.singleImage, "imageUrl", $event)
      }
    }
  })], 2), _vm._v(" "), _c('el-form-item', [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticClass: "req-star"
  }, [_vm._v("*")]), _vm._v("跳转链接")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "340px"
    },
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.dialogForm.redirectUrl),
      callback: function($$v) {
        _vm.$set(_vm.dialogForm, "redirectUrl", $$v)
      },
      expression: "dialogForm.redirectUrl"
    }
  })], 2), _vm._v(" "), _c('el-form-item', {
    staticClass: "popup-prompt-form-item",
    attrs: {
      "label": "是否弹窗提示",
      "required": ""
    }
  }, [_c('div', {
    staticClass: "popup-prompt-row"
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.dialogForm.isPopup),
      callback: function($$v) {
        _vm.$set(_vm.dialogForm, "isPopup", $$v)
      },
      expression: "dialogForm.isPopup"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("否")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), (_vm.dialogForm.isPopup === 1) ? _c('el-input', {
    staticClass: "popup-prompt-input",
    attrs: {
      "maxlength": "20",
      "placeholder": "请填写弹窗内容，最多20个字"
    },
    model: {
      value: (_vm.dialogForm.popupContent),
      callback: function($$v) {
        _vm.$set(_vm.dialogForm, "popupContent", $$v)
      },
      expression: "dialogForm.popupContent"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "popup-prompt-example"
  }, [_c('span', {
    staticClass: "popup-prompt-example-label"
  }, [_vm._v("示例")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.popupPromptExampleImg,
      "alt": "弹窗示例"
    }
  })])], 1)])] : _vm._e(), _vm._v(" "), ([2, 3].indexOf(_vm.dialogForm.decorationPosition) !== -1) ? [_c('el-form-item', [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticClass: "req-star"
  }, [_vm._v("*")]), _vm._v("起点图片")]), _vm._v(" "), _c('SUpload', {
    attrs: {
      "accept": "image/*",
      "type": "drag",
      "size": 50,
      "show-file-list": false
    },
    model: {
      value: (_vm.dialogForm.runEndpointIcons.startPointImage),
      callback: function($$v) {
        _vm.$set(_vm.dialogForm.runEndpointIcons, "startPointImage", $$v)
      },
      expression: "dialogForm.runEndpointIcons.startPointImage"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-hint"
  }, [_vm._v("尺寸要求32*32，最大50KB，优先SVG其次png")])], 2), _vm._v(" "), _c('el-form-item', [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticClass: "req-star"
  }, [_vm._v("*")]), _vm._v("终点图片")]), _vm._v(" "), _c('SUpload', {
    attrs: {
      "accept": "image/*",
      "type": "drag",
      "size": 50,
      "show-file-list": false
    },
    model: {
      value: (_vm.dialogForm.runEndpointIcons.endPointImage),
      callback: function($$v) {
        _vm.$set(_vm.dialogForm.runEndpointIcons, "endPointImage", $$v)
      },
      expression: "dialogForm.runEndpointIcons.endPointImage"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-hint"
  }, [_vm._v("尺寸要求32*32，最大50KB，优先SVG其次png")])], 2), _vm._v(" "), _c('el-form-item', [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticClass: "req-star"
  }, [_vm._v("*")]), _vm._v("定位图标")]), _vm._v(" "), _c('SUpload', {
    attrs: {
      "accept": "image/*",
      "type": "drag",
      "size": 50,
      "show-file-list": false
    },
    model: {
      value: (_vm.dialogForm.runEndpointIcons.locationIcon),
      callback: function($$v) {
        _vm.$set(_vm.dialogForm.runEndpointIcons, "locationIcon", $$v)
      },
      expression: "dialogForm.runEndpointIcons.locationIcon"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-hint"
  }, [_vm._v("尺寸要求32*32，最大50KB，优先SVG其次png")])], 2), _vm._v(" "), _c('div', {
    staticClass: "form-hint form-hint-warn",
    staticStyle: {
      "margin": "-10px 0 12px 90px",
      "color": "#f56c6c"
    }
  }, [_vm._v("以上三项至少上传一个")])] : _vm._e(), _vm._v(" "), (_vm.dialogForm.decorationPosition === 4) ? [_c('el-form-item', [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticClass: "req-star"
  }, [_vm._v("*")]), _vm._v("图片")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.dialogForm.pointImages,
      "border": "",
      "size": "small"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "位置",
      "prop": "label",
      "width": "70",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "render-header": function () { return _vm.renderRequiredHeader('未经过'); }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('SUpload', {
          attrs: {
            "accept": "image/*",
            "type": "drag",
            "size": 50,
            "show-file-list": false
          },
          model: {
            value: (row.notPassedUrl),
            callback: function($$v) {
              _vm.$set(row, "notPassedUrl", $$v)
            },
            expression: "row.notPassedUrl"
          }
        })]
      }
    }], null, false, 215359723)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "render-header": function () { return _vm.renderRequiredHeader('准备中（下一个点位）'); }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [(!row.hasPreparing) ? _c('span', [_vm._v("—")]) : _c('SUpload', {
          attrs: {
            "accept": "image/*",
            "type": "drag",
            "size": 50,
            "show-file-list": false
          },
          model: {
            value: (row.preparingUrl),
            callback: function($$v) {
              _vm.$set(row, "preparingUrl", $$v)
            },
            expression: "row.preparingUrl"
          }
        })]
      }
    }], null, false, 87730130)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "render-header": function () { return _vm.renderRequiredHeader('已经过'); }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('SUpload', {
          attrs: {
            "accept": "image/*",
            "type": "drag",
            "size": 50,
            "show-file-list": false
          },
          model: {
            value: (row.passedUrl),
            callback: function($$v) {
              _vm.$set(row, "passedUrl", $$v)
            },
            expression: "row.passedUrl"
          }
        })]
      }
    }], null, false, 2570713310)
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-hint"
  }, [_vm._v("点位图片尺寸要求32*32，最大50KB，优先SVG其次png")])], 2)] : _vm._e(), _vm._v(" "), (_vm.dialogForm.decorationPosition === 7) ? [_c('el-form-item', {
    attrs: {
      "label": "底部tab"
    }
  }, [_c('div', {
    staticClass: "theme-tab-wrap"
  }, [_vm._l((_vm.dialogForm.themeContent.bottomTabs), function(tab, idx) {
    return _c('div', {
      key: idx,
      staticClass: "theme-tab-box"
    }, [_c('i', {
      staticClass: "el-icon-circle-close theme-tab-close-btn",
      on: {
        "click": function($event) {
          return _vm.removeTab(idx)
        }
      }
    }), _vm._v(" "), _c('el-input', {
      staticStyle: {
        "width": "100%",
        "margin-bottom": "8px"
      },
      attrs: {
        "placeholder": "请输入Code"
      },
      model: {
        value: (tab.code),
        callback: function($$v) {
          _vm.$set(tab, "code", $$v)
        },
        expression: "tab.code"
      }
    }, [_c('template', {
      slot: "prepend"
    }, [_c('span', {
      staticClass: "req-star"
    }, [_vm._v("*")])])], 2), _vm._v(" "), _c('div', {
      staticClass: "theme-tab-imgs"
    }, [_c('div', {
      staticClass: "theme-tab-img-item"
    }, [_c('span', {
      staticClass: "theme-tab-img-label"
    }, [_c('span', {
      staticClass: "req-star"
    }, [_vm._v("*")]), _vm._v("未选中状态")]), _vm._v(" "), _c('UploadImg', {
      attrs: {
        "imgUrl": tab.unselectedIcon
      },
      on: {
        "update:imgUrl": function($event) {
          return _vm.$set(tab, "unselectedIcon", $event)
        },
        "update:img-url": function($event) {
          return _vm.$set(tab, "unselectedIcon", $event)
        }
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "theme-tab-img-item"
    }, [_c('span', {
      staticClass: "theme-tab-img-label"
    }, [_c('span', {
      staticClass: "req-star"
    }, [_vm._v("*")]), _vm._v("已选中状态")]), _vm._v(" "), _c('UploadImg', {
      attrs: {
        "imgUrl": tab.selectedIcon
      },
      on: {
        "update:imgUrl": function($event) {
          return _vm.$set(tab, "selectedIcon", $event)
        },
        "update:img-url": function($event) {
          return _vm.$set(tab, "selectedIcon", $event)
        }
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "theme-tab-img-item"
    }, [_c('span', {
      staticClass: "theme-tab-img-label"
    }, [_vm._v("回到顶部按钮")]), _vm._v(" "), _c('UploadImg', {
      attrs: {
        "imgUrl": tab.backToTopIcon
      },
      on: {
        "update:imgUrl": function($event) {
          return _vm.$set(tab, "backToTopIcon", $event)
        },
        "update:img-url": function($event) {
          return _vm.$set(tab, "backToTopIcon", $event)
        }
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "theme-tab-tips"
    }, [_vm._v("（尺寸：188*116，jpg、png）")])], 1)
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addTab
    }
  }, [_vm._v("添加")])], 2)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "背景图"
    }
  }, [_c('div', {
    staticClass: "theme-bg-row"
  }, [_c('div', {
    staticClass: "theme-bg-item"
  }, [_c('div', {
    staticClass: "theme-bg-label"
  }, [_vm._v("tab栏底部背景")]), _vm._v(" "), _c('UploadImg', {
    attrs: {
      "imgUrl": _vm.dialogForm.themeContent.backgrounds.tabBarBg
    },
    on: {
      "update:imgUrl": function($event) {
        return _vm.$set(_vm.dialogForm.themeContent.backgrounds, "tabBarBg", $event)
      },
      "update:img-url": function($event) {
        return _vm.$set(_vm.dialogForm.themeContent.backgrounds, "tabBarBg", $event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-hint"
  }, [_vm._v("（尺寸：750*166，jpg、png）")])], 1), _vm._v(" "), _c('div', {
    staticClass: "theme-bg-item"
  }, [_c('div', {
    staticClass: "theme-bg-label"
  }, [_vm._v("首页背景")]), _vm._v(" "), _c('UploadImg', {
    attrs: {
      "imgUrl": _vm.dialogForm.themeContent.backgrounds.homePageBg
    },
    on: {
      "update:imgUrl": function($event) {
        return _vm.$set(_vm.dialogForm.themeContent.backgrounds, "homePageBg", $event)
      },
      "update:img-url": function($event) {
        return _vm.$set(_vm.dialogForm.themeContent.backgrounds, "homePageBg", $event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-hint"
  }, [_vm._v("支持jpg、png、gif")])], 1), _vm._v(" "), _c('div', {
    staticClass: "theme-bg-item"
  }, [_c('div', {
    staticClass: "theme-bg-label"
  }, [_vm._v("我的页面背景")]), _vm._v(" "), _c('UploadImg', {
    attrs: {
      "imgUrl": _vm.dialogForm.themeContent.backgrounds.myPageBg
    },
    on: {
      "update:imgUrl": function($event) {
        return _vm.$set(_vm.dialogForm.themeContent.backgrounds, "myPageBg", $event)
      },
      "update:img-url": function($event) {
        return _vm.$set(_vm.dialogForm.themeContent.backgrounds, "myPageBg", $event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-hint"
  }, [_vm._v("支持jpg、png、gif")])], 1), _vm._v(" "), _c('div', {
    staticClass: "theme-bg-item"
  }, [_c('div', {
    staticClass: "theme-bg-label"
  }, [_vm._v("广场页背景")]), _vm._v(" "), _c('UploadImg', {
    attrs: {
      "imgUrl": _vm.dialogForm.themeContent.backgrounds.squarePageBg
    },
    on: {
      "update:imgUrl": function($event) {
        return _vm.$set(_vm.dialogForm.themeContent.backgrounds, "squarePageBg", $event)
      },
      "update:img-url": function($event) {
        return _vm.$set(_vm.dialogForm.themeContent.backgrounds, "squarePageBg", $event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-hint"
  }, [_vm._v("支持jpg、png、gif")])], 1), _vm._v(" "), _c('div', {
    staticClass: "theme-bg-item"
  }, [_c('div', {
    staticClass: "theme-bg-label"
  }, [_vm._v("运动页背景")]), _vm._v(" "), _c('UploadImg', {
    attrs: {
      "imgUrl": _vm.dialogForm.themeContent.backgrounds.sportsPageBg
    },
    on: {
      "update:imgUrl": function($event) {
        return _vm.$set(_vm.dialogForm.themeContent.backgrounds, "sportsPageBg", $event)
      },
      "update:img-url": function($event) {
        return _vm.$set(_vm.dialogForm.themeContent.backgrounds, "sportsPageBg", $event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-hint"
  }, [_vm._v("支持jpg、png、gif")])], 1)])])] : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "生效时间",
      "prop": "timeRange"
    }
  }, [_c('div', {
    staticClass: "time-range-row"
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "190px"
    },
    attrs: {
      "type": "datetime",
      "placeholder": "开始时间",
      "value-format": "yyyy-MM-dd HH:mm:ss"
    },
    on: {
      "change": _vm.onTimeChange
    },
    model: {
      value: (_vm.dialogForm.startTime),
      callback: function($$v) {
        _vm.$set(_vm.dialogForm, "startTime", $$v)
      },
      expression: "dialogForm.startTime"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "time-range-sep"
  }, [_vm._v("To")]), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "190px"
    },
    attrs: {
      "type": "datetime",
      "placeholder": "结束时间",
      "value-format": "yyyy-MM-dd HH:mm:ss"
    },
    on: {
      "change": _vm.onTimeChange
    },
    model: {
      value: (_vm.dialogForm.endTime),
      callback: function($$v) {
        _vm.$set(_vm.dialogForm, "endTime", $$v)
      },
      expression: "dialogForm.endTime"
    }
  })], 1)])], 2), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submitLoading
    },
    on: {
      "click": _vm.submitDialog
    }
  }, [_vm._v("确认")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-136541b0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/OperationManage/UserAdminister/PlatformDecoration/PlatformDecoration.vue
// module id = 946
// module chunks = 0